(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  var NAME_RE = /^[a-zA-ZçÇöÖşŞıİğĞüÜ\s]+$/;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var PHONE_ALLOWED_KEYS = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End"];
  var CONTACT_ENDPOINT = "/save-contactUs-form";

  DNB.ContactForm = {
    _t: function (tr, en) {
      var lang = (document.documentElement.getAttribute("lang") || "tr").toLowerCase();
      return lang.indexOf("en") === 0 ? en : tr;
    },

    init: function () {
      var forms = document.querySelectorAll("[data-contact-form]");
      if (!forms.length) return;

      Array.prototype.forEach.call(forms, function (form) {
        DNB.ContactForm._bind(form);
      });
    },

    _bind: function (form) {
      var self = this;
      var submitBtn = form.querySelector("[data-contact-submit]");
      var success = form.parentNode.querySelector("[data-contact-success]");

      Array.prototype.forEach.call(form.querySelectorAll('[data-rule="phone"], [data-rule="phone-optional"]'), function (input) {
        self._initPhoneField(input);
      });

      function handle(e) {
        if (e) e.preventDefault();
        if (self._isSubmitting(form)) return;

        var valid = self._validate(form);
        if (!valid) return;

        var endpoint = self._resolveEndpoint(form);
        if (endpoint) {
          self._lockSubmit(form, submitBtn);
          self._submit(form, endpoint, submitBtn, success);
          return;
        }

        if (success) {
          success.classList.add("is-active");
          form.reset();
        }
      }

      form.addEventListener("submit", handle);
      if (submitBtn) submitBtn.addEventListener("click", handle);

      var controls = form.querySelectorAll(".form-field__control, .form-check__input");
      Array.prototype.forEach.call(controls, function (ctrl) {
        var ev = ctrl.tagName === "SELECT" || ctrl.type === "checkbox" ? "change" : "input";
        ctrl.addEventListener(ev, function () {
          var wrap = ctrl.closest(".form-field, .form-check");
          if (wrap && self._checkControl(ctrl)) wrap.classList.remove("is-error");
          self._hideFormError(form, submitBtn);
        });
      });
    },

    _initPhoneField: function (input) {
      var self = this;

      input.setAttribute("inputmode", "numeric");
      input.setAttribute("autocomplete", "tel-national");
      input.setAttribute("maxlength", "13");

      input.addEventListener("keydown", function (e) {
        if (e.ctrlKey || e.metaKey || e.altKey) return;
        if (PHONE_ALLOWED_KEYS.indexOf(e.key) !== -1) return;
        if (!/^\d$/.test(e.key)) e.preventDefault();
      });

      input.addEventListener("input", function () {
        var formatted = self._formatTrPhone(input.value);
        if (input.value !== formatted) input.value = formatted;
      });

      input.addEventListener("paste", function (e) {
        e.preventDefault();
        var pasted = (e.clipboardData || window.clipboardData).getData("text");
        input.value = self._formatTrPhone(pasted);
      });
    },

    _formatTrPhone: function (value) {
      var digits = String(value || "").replace(/\D/g, "").slice(0, 10);
      var parts = [];

      if (digits.length > 0) parts.push(digits.slice(0, 3));
      if (digits.length > 3) parts.push(digits.slice(3, 6));
      if (digits.length > 6) parts.push(digits.slice(6, 8));
      if (digits.length > 8) parts.push(digits.slice(8, 10));

      return parts.join(" ");
    },

    _validate: function (form) {
      var self = this;
      var controls = form.querySelectorAll("[data-rule]");
      var firstInvalid = null;

      Array.prototype.forEach.call(controls, function (ctrl) {
        var wrap = ctrl.closest(".form-field, .form-check");
        if (!wrap) return;
        var ok = self._checkControl(ctrl);
        wrap.classList.toggle("is-error", !ok);
        if (!ok && !firstInvalid) firstInvalid = ctrl;
      });

      if (firstInvalid && firstInvalid.focus) {
        try { firstInvalid.focus(); } catch (err) {}
      }
      return !firstInvalid;
    },

    _checkControl: function (ctrl) {
      var rule = ctrl.getAttribute("data-rule");
      var val = (ctrl.value || "").trim();

      switch (rule) {
        case "name":
          if (typeof ValidateName === "function") {
            return ValidateName(val);
          }
          return val.length >= 2 && NAME_RE.test(val);
        case "email":
          if (typeof ValidateMail === "function") {
            return ValidateMail(val);
          }
          return EMAIL_RE.test(val);
        case "phone":
        case "phone-optional": {
          var digits = val.replace(/\D/g, "");
          if (rule === "phone-optional" && digits.length === 0) return true;
          if (digits.length !== 10) return false;
          if (typeof ValidatePhone === "function") {
            return ValidatePhone(digits);
          }
          return /^\d{10}$/.test(digits);
        }
        case "select":
          return val !== "";
        case "checkbox":
          return ctrl.checked === true;
        case "required":
        default:
          return val.length >= 2;
      }
    },

    _resolveEndpoint: function (form) {
      var endpoint = form.getAttribute("data-contact-endpoint");
      if (endpoint) return endpoint;
      if (form.querySelector('[name="subject"]')) return CONTACT_ENDPOINT;
      return "";
    },

    _isSubmitting: function (form) {
      return form.getAttribute("data-contact-submitting") === "true";
    },

    _setSubmitting: function (form, isSubmitting) {
      if (isSubmitting) {
        form.setAttribute("data-contact-submitting", "true");
      } else {
        form.removeAttribute("data-contact-submitting");
      }
    },

    _lockSubmit: function (form, submitBtn) {
      this._setSubmitting(form, true);

      if (!submitBtn) return;

      submitBtn.disabled = true;
      submitBtn.setAttribute("disabled", "disabled");
      submitBtn.setAttribute("aria-busy", "true");
    },

    _unlockSubmit: function (form, submitBtn) {
      this._setSubmitting(form, false);

      if (!submitBtn) return;

      submitBtn.disabled = false;
      submitBtn.removeAttribute("disabled");
      submitBtn.removeAttribute("aria-busy");
    },

    _splitFullName: function (fullName) {
      var trimmed = String(fullName || "").trim();
      if (!trimmed) return { name: "", surname: "" };

      var parts = trimmed.split(/\s+/);
      return {
        name: parts[0],
        surname: parts.length > 1 ? parts.slice(1).join(" ") : "-"
      };
    },

    _buildPayload: function (form) {
      var fullNameEl = form.querySelector('[name="fullname"]');
      var emailEl = form.querySelector('[name="email"]');
      var phoneEl = form.querySelector('[name="phone"]');
      var messageEl = form.querySelector('[name="message"]');
      var subjectEl = form.querySelector('[name="subject"]');
      var consentBoxes = form.querySelectorAll('[data-rule="checkbox"]');
      var consentAccepted = true;
      Array.prototype.forEach.call(consentBoxes, function (box) {
        if (!box.checked) consentAccepted = false;
      });

      var fullName = fullNameEl ? fullNameEl.value.trim() : "";
      var split = this._splitFullName(fullName);
      var payload = new FormData();

      payload.append("FullName", fullName);
      payload.append("Name", split.name);
      payload.append("Surname", split.surname);
      payload.append("Email", emailEl ? emailEl.value.trim() : "");
      payload.append("Phone", phoneEl ? phoneEl.value.replace(/\D/g, "") : "");
      payload.append("Message", messageEl ? messageEl.value.trim() : "");
      payload.append("ContactReasonId", subjectEl ? subjectEl.value : "");
      payload.append("PrivacyKvkk", consentAccepted ? "true" : "false");
      payload.append("CommunicationPermit", "false");

      return payload;
    },

    _getErrorEl: function (form, submitBtn) {
      var container = form.parentNode;
      var errorEl = container ? container.querySelector("[data-contact-error]") : null;

      if (!errorEl && container && submitBtn) {
        errorEl = document.createElement("p");
        errorEl.className = "cform__note is-error";
        errorEl.setAttribute("data-contact-error", "");
        errorEl.hidden = true;
        submitBtn.parentNode.insertBefore(errorEl, submitBtn);
      }

      return errorEl;
    },

    _showFormError: function (form, submitBtn, message) {
      var errorEl = this._getErrorEl(form, submitBtn);
      if (!errorEl) return;

      errorEl.textContent = message;
      errorEl.hidden = false;
      errorEl.classList.add("is-error");
      errorEl.setAttribute("role", "alert");
    },

    _hideFormError: function (form, submitBtn) {
      var errorEl = this._getErrorEl(form, submitBtn);
      if (!errorEl) return;

      errorEl.textContent = "";
      errorEl.hidden = true;
      errorEl.removeAttribute("role");
    },

    _submit: function (form, endpoint, submitBtn, success) {
      var self = this;

      self._hideFormError(form, submitBtn);
      if (success) success.classList.remove("is-active");

      fetch(endpoint, {
        method: "POST",
        body: self._buildPayload(form),
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        }
      })
        .then(function (response) {
          return response.json().catch(function () {
            return { success: false, message: DNB.ContactForm._t("Sunucudan geçersiz yanıt alındı.", "An invalid response was received from the server.") };
          });
        })
        .then(function (data) {
          if (data && data.success === true) {
            if (success) success.classList.add("is-active");
            form.reset();
            return;
          }

          self._showFormError(
            form,
            submitBtn,
            (data && data.message) || DNB.ContactForm._t("Form gönderilemedi. Lütfen tekrar deneyin.", "The form could not be sent. Please try again.")
          );
        })
        .catch(function () {
          self._showFormError(
            form,
            submitBtn,
            DNB.ContactForm._t("Beklenmedik bir hata oluştu. Lütfen tekrar deneyiniz.", "An unexpected error occurred. Please try again.")
          );
        })
        .finally(function () {
          self._unlockSubmit(form, submitBtn);
        });
    }
  };
})(window, document);
